import { ApplicantProvidedDocumentType } from '../../types/authenticateSmartcheckSessionDto'

export interface IncomeVerificationResponseDto {
	incomeChains: IncomeChainDto[]
	incomeVerificationPreviouslyCompleted: boolean
}

export interface IncomeVerificationUpdateRequestDto {
	incomeChains: IncomeChainDto[]
	userNote?: string
}

export interface IncomeChainDto {
	id: number
	typeOfIncome: TypeOfIncome | null
	assessment?: Assessment
	monthlyValue: number
	range: IncomeRange
	highVariability: boolean
	transactions: IncomeAssessmentTransactionDto[]
	owner?: IncomeChainAssociationEnum
}

export interface IncomeVerificationDto extends IncomeVerificationResponseDto {
	incomeChains: IncomeChain[]
	userNote?: string
}

export interface IncomeChain extends IncomeChainDto {
	hasLargeInputDifferences?: boolean
}

interface TypeOfIncome {
	code: CategoryId
	description?: string
}
interface Assessment {
	value?: number | null
}

export interface IncomeRange {
	min: number
	max: number
}

export interface IncomeAssessmentTransactionDto {
	text: string
	date: string
	amount: number
}

export enum IncomeChainAssociationEnum {
	Mine = 1,
	Partner = 2,
	Unknown = 3,
}

export interface IncomeVerificationFormData
	extends IncomeVerificationUpdateRequestDto {
	incomeChains: IncomeChain[]
	uploadedFiles?: File[]
	categorizedDocuments?: CategorizedDocument[]
}

export type CategorizedDocument = [File, ApplicantProvidedDocumentType]

export enum CategoryId {
	Uncategorized = 0,
	ChildBenefit = 23,
	MaternityBenefits = 77,
	OtherIncome = 89,
	StatePension = 98,
	Salary = 110,
	SicknessBenefits = 112,
	StudentStipend = 117,
	UnemploymentBenefits = 133,
	DisabilityPension = 378,
	OtherSalaryAndIncome = 379,
	WelfareIncome = 447,
	MinimumSocialBenefits = 501,
}
